import { useTheme } from "@emotion/react";
import { Check, CircleOutlined } from "@mui/icons-material";
import React from "react";
import { StudentGrade } from "../../common/const";
import CommonButton from "../../common/components/CommonButton";
import { Box } from "@mui/material";

const CommonGradeButton = ({
    currentGrade,
    setCurrentGrade,
    setDefaultGrade
}) => {
    const theme = useTheme();
    return (
        StudentGrade.map((a, index) => (
            <CommonButton
                key={index}
                label={a.label}
                size="small"
                height="37px"
                marginBottom="0px"
                fontWeight="bold"
                width="12%"
                background={currentGrade === a.value ? theme.palette.primary.main : theme.palette.background.main}
                color={currentGrade === a.value ? theme.palette.secondary.main : theme.palette.background.dark}
                handleClick={() => {
                    setCurrentGrade(a.value);
                    if(setDefaultGrade) {
                        setDefaultGrade(a.value);
                    }
                }}
                startIcon={currentGrade === a.value ? (
                    <Box sx={{ background: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0.3 }}>
                        <Check sx={{ fontSize: 12 }} />
                    </Box>
                ) : <CircleOutlined />}
            />
        ))
    )
}

export default CommonGradeButton;